module.exports = __webpack_public_path__ + "static/AvenirNext-Bold-277b05c2a9797f3b7f914e5ffe3328fe.woff";